export const UNIT_ABBREVIATIONS: Record<string, string> = {
  kilos: 'kg',
  pounds: 'lb',
}
